import { render, staticRenderFns } from "./EntitiesListWidget.vue?vue&type=template&id=70c6396c"
import script from "./EntitiesListWidget.vue?vue&type=script&lang=js"
export * from "./EntitiesListWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports